import { render, staticRenderFns } from "./FloatingPriceCard.vue?vue&type=template&id=10a9b242&scoped=true&"
import script from "./FloatingPriceCard.vue?vue&type=script&lang=js&"
export * from "./FloatingPriceCard.vue?vue&type=script&lang=js&"
import style0 from "./FloatingPriceCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FloatingPriceCard.vue?vue&type=style&index=1&id=10a9b242&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a9b242",
  null
  
)

export default component.exports